var _circle, _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFb(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "5.39vw",
    height: "5.39vw",
    viewBox: "0 0 78 78",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 38.8216,
    cy: 38.8216,
    r: 38.3216,
    stroke: "#683FDB"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M45.6707 25.1768V29.4408H42.742C42.3909 29.4408 41.9251 29.527 41.5377 29.8434C41.1311 30.1755 40.8853 30.7 40.8853 31.4209V34.6111V35.1111H41.3853H45.6904L45.2336 39.5379H41.3853H40.8853V40.0379V53.3925H35.5047V40.0379V39.5379H35.0047H32.4707V35.1111H35.0047H35.5047V34.6111V31.1002C35.5047 29.9113 35.7896 28.4189 36.6593 27.2371C37.5098 26.0814 38.9627 25.1623 41.442 25.1621C41.4423 25.1621 41.4425 25.1621 41.4428 25.1621L45.6707 25.1768Z",
    fill: "#683FDB",
    stroke: "#683FDB"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFb);
export default __webpack_public_path__ + "static/media/fb.15a740e8b8d928d35f7edaf4ebae4c7f.svg";
export { ForwardRef as ReactComponent };